import { render, staticRenderFns } from "./u-card-border-top-outlined.vue?vue&type=template&id=3fa62cd6&scoped=true"
import script from "./u-card-border-top-outlined.vue?vue&type=script&lang=js"
export * from "./u-card-border-top-outlined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa62cd6",
  null
  
)

export default component.exports